import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import api from '../../services/api';
import { CheckCircle, Lock } from 'lucide-react';

export default function RedefinirSenha() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [senha, setSenha] = useState('');
  const [confirma, setConfirma] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (senha.length < 6) { setError('A senha deve ter no mínimo 6 caracteres'); return; }
    if (senha !== confirma) { setError('As senhas não coincidem'); return; }
    setLoading(true);
    try {
      await api.post('/auth/reset-password', { token, new_password: senha });
      setSuccess(true);
    } catch (err) {
      setError(err.response?.data?.detail || 'Link inválido ou expirado. Solicite um novo.');
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="min-h-screen bg-gradient-to-b from-brand-dark to-brand-primary flex flex-col items-center justify-center px-6">
        <div className="max-w-sm w-full text-center space-y-5">
          <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center mx-auto">
            <CheckCircle className="w-8 h-8 text-white" />
          </div>
          <div>
            <p className="text-white font-heading text-2xl font-bold">Senha alterada!</p>
            <p className="text-white/70 text-sm font-body mt-2">
              Sua senha foi atualizada com sucesso. Já pode fazer login.
            </p>
          </div>
          <button
            onClick={() => navigate('/login')}
            className="w-full py-3.5 rounded-xl bg-white text-brand-primary font-dashboard font-bold text-sm"
            data-testid="go-login-btn"
          >
            Ir para o Login
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-brand-dark to-brand-primary flex flex-col">
      <div className="flex-1 flex flex-col justify-center px-6 py-10 max-w-sm mx-auto w-full">

        <div className="text-center mb-8">
          <img src="/logo-fatima.jpg" alt="Fátima Guterres" className="w-36 h-auto rounded-xl mx-auto mb-4 shadow-lg object-cover" />
          <h1 className="font-heading text-2xl text-white font-bold">Nova Senha</h1>
          <p className="text-white/70 text-sm mt-1 font-body">Digite sua nova senha de acesso</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm text-white/80 mb-1.5 font-body">Nova senha</label>
            <input
              type="password"
              className="w-full rounded-xl border border-white/20 bg-white/10 px-4 py-3 text-white placeholder-white/40 text-sm font-body focus:outline-none focus:ring-2 focus:ring-white/40"
              placeholder="Mínimo 6 caracteres"
              value={senha}
              onChange={e => setSenha(e.target.value)}
              required
              data-testid="field-nova-senha"
            />
          </div>
          <div>
            <label className="block text-sm text-white/80 mb-1.5 font-body">Confirmar nova senha</label>
            <input
              type="password"
              className="w-full rounded-xl border border-white/20 bg-white/10 px-4 py-3 text-white placeholder-white/40 text-sm font-body focus:outline-none focus:ring-2 focus:ring-white/40"
              placeholder="Repita a senha"
              value={confirma}
              onChange={e => setConfirma(e.target.value)}
              required
              data-testid="field-confirma-senha"
            />
          </div>

          {error && (
            <p className="text-red-300 text-sm font-body text-center">{error}</p>
          )}

          <button
            type="submit"
            disabled={loading}
            className="w-full py-3.5 rounded-xl bg-white text-brand-primary font-dashboard font-bold text-sm hover:bg-white/90 transition-colors disabled:opacity-60 flex items-center justify-center gap-2"
            data-testid="submit-reset-btn"
          >
            <Lock className="w-4 h-4" />
            {loading ? 'Salvando...' : 'Salvar nova senha'}
          </button>
        </form>

        <Link to="/login" className="text-white/60 text-sm font-body text-center mt-6 block underline">
          Voltar ao login
        </Link>
      </div>
    </div>
  );
}
